// extracted by mini-css-extract-plugin
export var addToCartButton = "_jq-b";
export var arrowButtonContainer = "_jq-9";
export var arrowButtonIcon = "_jq-a";
export var carouselArrowButton = "_jq-6";
export var carouselElementContainer = "_jq-1";
export var left = "_jq-7";
export var productDisplayCarouselContainer = "_jq-0";
export var productTileContainer = "_jq-2";
export var productTileImage = "_jq-4";
export var productTileImageContainer = "_jq-3";
export var productTileTitle = "_jq-5";
export var right = "_jq-8";
export var sliderOverflow = "_jq-c";